// components/EventsCardsView.jsx

import React from "react";
import {
  FaArrowDown,
  FaArrowUp,
  FaHistory,
  FaRegCalendarCheck,
} from "react-icons/fa";

import EventCard from "../EventCard";

import { extractEventCategories } from "../utils/calendarUtils";

export default function EventsCardsView({
  events = [],
  loading = false,

  showPast,
  sortOrder,

  onChangeShowPast,
  onChangeSortOrder,
  onSelectEvent,
}) {
  return (
    <section className="space-y-4">
      {/* BARRE DE LA VUE CARTES */}
      <div className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-3 dark:border-white/10 dark:bg-slate-900 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-sm font-black text-slate-900 dark:text-white">
            {events.length} événement
            {events.length > 1 ? "s" : ""}{" "}
            {showPast ? "passé(s)" : "à venir"}
          </p>

          <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
            Cliquez sur le bouton d’information pour afficher
            la fiche complète.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => onChangeShowPast(!showPast)}
            className={[
              "inline-flex min-h-10 items-center gap-2 rounded-xl border px-3 py-2",
              "text-sm font-bold transition",
              "border-slate-200 bg-white text-slate-700 hover:bg-slate-50",
              "dark:border-white/10 dark:bg-slate-800 dark:text-slate-200",
            ].join(" ")}
          >
            {showPast ? (
              <>
                <FaRegCalendarCheck />
                Voir les événements à venir
              </>
            ) : (
              <>
                <FaHistory />
                Voir les événements passés
              </>
            )}
          </button>

          <label className="inline-flex min-h-10 items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 dark:border-white/10 dark:bg-slate-800">
            {sortOrder === "asc" ? (
              <FaArrowDown className="text-slate-400" />
            ) : (
              <FaArrowUp className="text-slate-400" />
            )}

            <select
              value={sortOrder}
              onChange={(event) =>
                onChangeSortOrder(event.target.value)
              }
              className="bg-transparent text-sm font-bold text-slate-700 outline-none dark:text-slate-200"
            >
              <option value="asc">
                Date croissante
              </option>

              <option value="desc">
                Date décroissante
              </option>
            </select>
          </label>
        </div>
      </div>

      {/* CONTENU */}
      {loading && events.length === 0 ? (
        <div className="rounded-2xl border border-slate-200 bg-white p-10 text-center dark:border-white/10 dark:bg-slate-900">
          Chargement des événements…
        </div>
      ) : events.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center dark:border-white/15 dark:bg-slate-900">
          <p className="font-bold text-slate-700 dark:text-slate-200">
            Aucun événement ne correspond aux filtres.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {events.map((event) => (
            <EventCard
              key={event.id}
              event={event}
              categories={extractEventCategories(
                event.cate_event
              )}
              onOpenDetails={() =>
                onSelectEvent(event)
              }
            />
          ))}
        </div>
      )}
    </section>
  );
}